import React from 'react';
import { ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/24/outline';

interface EstablishmentStatusBannerProps {
  etatAdministratifEtablissement: string;
}

const EstablishmentStatusBanner: React.FC<EstablishmentStatusBannerProps> = ({ 
  etatAdministratifEtablissement 
}) => {
  // Don't show banner if establishment is active
  if (etatAdministratifEtablissement === 'A') {
    return null;
  }

  // Determine the type of closure and styling
  const isClosed = etatAdministratifEtablissement === 'F';
  const isCeased = etatAdministratifEtablissement === 'C';
  
  if (!isClosed && !isCeased) {
    return null;
  }

  const getBannerContent = () => {
    if (isClosed) {
      return {
        icon: XCircleIcon,
        title: 'Établissement fermé',
        message: 'Cet établissement adhérent est actuellement fermé selon les données officielles INSEE.',
        bgColor: 'bg-red-50',
        borderColor: 'border-red-200',
        iconColor: 'text-red-600',
        titleColor: 'text-red-800',
        messageColor: 'text-red-700'
      };
    } else if (isCeased) {
      return {
        icon: ExclamationTriangleIcon,
        title: 'Établissement cessé',
        message: 'Cet établissement adhérent a cessé son activité selon les données officielles INSEE.',
        bgColor: 'bg-orange-50',
        borderColor: 'border-orange-200',
        iconColor: 'text-orange-600',
        titleColor: 'text-orange-800',
        messageColor: 'text-orange-700'
      };
    }
  };

  const content = getBannerContent();
  if (!content) return null;

  const { icon: Icon, title, message, bgColor, borderColor, iconColor, titleColor, messageColor } = content;

  return (
    <div className={`${bgColor} ${borderColor} border-l-4 p-4 mb-6`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon className={`h-5 w-5 ${iconColor}`} aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium ${titleColor}`}>
            {title}
          </h3>
          <div className={`mt-2 text-sm ${messageColor}`}>
            <p>
              {message}
            </p>
            <p className="mt-1">
              <span className="font-medium">Pensez à mettre à jour la fiche adhérent pour conserver les informations à jour.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstablishmentStatusBanner; 